<!-- 试题展示 -->
<template>
    <li class="question-view">
        <div class="stem">
            <label for="stem" class="stem--label">{{ isQuestion ? "题目：" : question.text + "：" }}</label>
            <textarea class="stem--input"
                      :value="question.stem"
                      @input="onStemChange"
                      ref="stem"
                      id="stem"
                      minlength="5"
                      maxlength="300"
                      rows="1"/>
        </div>
        <!-- 当为问卷试题时渲染 -->
        <template v-if="isQuestion">
            <!-- 备注 -->
            <div class="stem-remark">
                <label for="remark" class="stem-remark--label">备注：</label>
                <textarea class="stem-remark--input"
                          :value="question.remark"
                          @input="(e) => onChange(e, 'remark')"
                          ref="remark"
                          id="remark"
                          wrap="soft"
                          minlength="5"
                          maxlength="150"
                          rows="1"/>
            </div>
            <!-- 渲染题型 -->
            <el-select v-model="question.type"
                       @change="onQuestionTypeChange"
                       size="medium" class="question-select">
                <el-option
                    v-for="item in Object.keys(QUESTION_VAL)"
                    :label="QUESTION_TITLE[item]"
                    :key="QUESTION_VAL[item]"
                    :value="QUESTION_VAL[item]"/>
            </el-select>
            <el-checkbox :value="question.required"
                         @input="handleRequired"
                         style="margin-left: 16px"
                         size="medium">必填</el-checkbox>
            <template v-if="[QUESTION_VAL.single, QUESTION_VAL.multiple].includes(question.type)">
                <transition-group name="fade-top">
                    <div class="options-textarea"
                         v-for="(option, index) in question.options"
                         :key="`textarea${index}`">
                        <el-popover
                            placement="top-start"
                            width="400"
                            v-model="showOptionsToolBar[index]"
                            trigger="hover">
                            <div class="options-tools">
                                <i class="el-icon-picture-outline"
                                   style="font-size: 20px; cursor: pointer"
                                   @click.stop="uploadImg(index)"
                                   title="图片上传"/>
                            </div>
                            <textarea class="question-textarea"
                                      :value="option.text"
                                      v-if="option.type === 'text'"
                                      @input="(e) => onQuestionOptionChange(e, index)"
                                      rows="1"
                                      slot="reference"
                                      ref="option"
                            />
                        </el-popover>
                        <img v-if="option.type === 'image'"
                             style="width: 600px;"
                             :src="option.text" alt="options-image"/>
                        <span class="el-icon-close options-textarea--close" @click.stop="handleDel(index)"/>
                    </div>
                </transition-group>
                <div class="new-options" @click.stop="handleNewOptions">新建选项</div>
            </template>
        </template>
        <el-row type="flex" justify="end" style="margin-top: 20px">
            <el-button type="text" style="margin-right: 20px"
                       @click.stop="onCancel">取消</el-button>
            <el-button type="primary" size="medium"
                       @click.stop="onConfirm">确定</el-button>
        </el-row>
    </li>
</template>

<script>
import { QUESTION_VAL, QUESTION_TITLE } from "@/utils/question-config"
import { uploadFile } from "@/api/manage";
import { uploadOfInput } from "@/utils"
export default {
    name: "QuestionView",
    props: {
        question: {
            type: Object,
            default() {
                return {}
            }
        },
        number: {
            type: [Number, String],
        },
        // 全量编辑模式下的活跃的问卷试题
        isActive: {
            type: Boolean
        }
    },
    data() {
        return {
            QUESTION_VAL: Object.freeze(QUESTION_VAL),
            QUESTION_TITLE: Object.freeze(QUESTION_TITLE),
            showOptionsToolBar: {}
        }
    },
    computed: {
        // 是否是问卷试题
        isQuestion({ question }) {
            return Object.values(QUESTION_VAL).includes(question.type)
        },
    },
    mounted() {
        const { scrollHeight, clientHeight } = this.$refs.stem
        this.textareaClientHeight = clientHeight
        this.$refs.stem.style.height = scrollHeight + "px"
        this.originQuestion = JSON.parse(JSON.stringify(this.question))
    },
    methods: {
        /**
         * 监听问卷试题选项变化
         * @param e { HTMLElement }
         * @param index { Number }
         * @return { undefined }
         */
        onQuestionOptionChange(e, index) {
            const value = e.target.value
            const options = this.question.options
            options[index].text = value
            this.$refs.option[index].style.height = this.textareaClientHeight + "px"
            this.$refs.option[index].style.height = e.target.scrollHeight + "px";
            // 更新父组件问卷试题
            this.$emit("update:question", Object.assign(this.question, { options }))
            this.$emit("change", `option.${index}`, value)
        },
        // 监听题干变化
        onStemChange(e) {
            const value = e.target.value
            if (!value) {
                this.$message.warning("题干不能为空")
            }
            this.onChange(e, "stem")
        },
        /**
         * 监听文本域变化
         * @param e {HTMLElement} 要显示的文字
         * @param type { string } 类型
         * @return { undefined }
         */
        onChange(e, type) {
            const value = e.target.value
            this.$refs[type].style.height = this.textareaClientHeight + "px"
            this.$refs[type].style.height = e.target.scrollHeight + "px";
            // 更新父组件问卷试题
            this.$emit("update:question", Object.assign(this.question, { [type]: value }))
            this.$emit("change", type, value)
        },
        // 聚焦
        focus(isSelect, type) {
            if (type === "options") {
                this.$refs.stemOptions.focus()
                if (isSelect) this.select(type)
            } else {
                this.$refs.stem.focus()
                if (isSelect) this.select(type)
            }
        },
        // 选中
        select(type) {
            if (type === "options") {
                this.$nextTick(() => {
                    this.$refs.stemOptions.select()
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.stem.select()
                })
            }
        },
        // 处理新建选项
        handleNewOptions() {
            if (Array.isArray(this.question.options)) {
                this.question.options.push({
                    type: "text",
                    text: `选项${this.question.options.length + 1}`
                })
            } else {
                this.question.options = [{
                    type: "text",
                    text: "选项1"
                }]
            }
            this.$emit("update:question", this.question)
        },
        // 删除选项
        handleDel(index) {
            if (this.question.options.length <= 1) return this.$message.warning("单选多选选项不能为空")
            this.question.options.splice(index, 1)
            this.$emit("update:question", this.question)
        },
        // 处理必填
        handleRequired (val) {
            this.$set(this.question, "required", val)
            this.$emit("update:question", this.question)
        },
        uploadImg(index) {
            uploadOfInput((file) => {
                if (!file) return
                uploadFile({ file }).then(res => {
                    const options = this.question.options
                    options[index].type = "image"
                    options[index].text = res
                    // 更新父组件问卷试题
                    this.$emit("update:question", Object.assign(this.question, { options }))
                    this.$emit("change", `option.${index}`, res)
                    this.$message.success("上传成功")
                })
            })
        },
        // 取消
        onCancel() {
            this.$emit("cancel", this.originQuestion)
        },
        // 确定
        onConfirm() {
            const type = this.question.type
            if (type === "textDesc") {
                if (!this.question.stem) {
                    this.$message.warning("文本描述不能为空")
                } else {
                    this.$emit("confirm")
                }
            } else {
                if (!this.question.stem) {
                    this.$message.warning("题干不能为空")
                } else {
                    this.$emit("confirm")
                }
            }
        },

        onQuestionTypeChange (val) {
            this.question.text = QUESTION_TITLE[val]
        }
    }
}
</script>

<style scoped lang="less">
.question-textarea {
    font-size: 18px;
    font-weight: 500;
    box-sizing: border-box;
    display: block;
    padding: 8px;
    width: 700px;
}

.options-textarea {
    display: flex;
    align-items: center;
    margin: 20px 0 0 60px;

    &--close {
        font-size: 20px;
        color: #BABFCB;
        margin-left: 18px;
        cursor: pointer;
    }
}

.question-view {
    padding: 20px 30px 10px 30px;
    margin-bottom: 30px;
}

.stem, .stem-remark {
    font-size: 18px;
    font-weight: 500;
    transition: all .4s;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    &--input {
        flex: 1;
        font-size: 18px;
        font-weight: 500;
        transition: background-color .4s;
        box-sizing: border-box;
        display: inline-block;
        word-break: break-all;
        vertical-align: middle;
        padding: 8px;
    }

    &-options {
        padding: 10px 30px;
        display: block;
        width: 100%;
        border: 1px dashed #fff;
        transition: all .5s;

        &--input {
            display: inline-block;
            padding: 5px 10px;
            min-width: 450px;
            transition: all .5s;
            word-break: break-all;
        }
    }

    &--label {
        min-width: 60px;
    }
}

.stem-remark {
    margin: 20px 0;
}

.new-options {
    margin-top: 20px;
    padding: 10px;
    cursor: pointer;
    border: 1px dashed #BABFCB;
    margin-left: 60px;
    box-sizing: border-box;
    font-size: 16px;
}

.question-select {
    margin-left: 60px;
}

.el-divider__text {
    background-color: #F1F2F6;
    cursor: pointer;
}
</style>
